import { useScrollAnimation } from "../../../hooks/useScrollAnimation";

const steps = [
  {
    number: "01",
    icon: "ri-search-eye-line",
    title: "現状分析",
    description: "事業課題と現状の広告・LP・計測状況を整理し、改善余地を把握します。",
  },
  {
    number: "02",
    icon: "ri-file-list-3-line",
    title: "条件設計",
    description: "契約範囲、評価指標、報酬条件を明確にし、双方の合意のもとで設計します。",
  },
  {
    number: "03",
    icon: "ri-line-chart-line",
    title: "実行・計測",
    description: "設計した施策を実行し、コンバージョンと採算を継続的に計測します。",
  },
  {
    number: "04",
    icon: "ri-refresh-line",
    title: "検証・改善",
    description: "数値に基づく検証を重ね、費用対効果の向上につながる改善を積み重ねます。",
  },
];

export default function BusinessModel() {
  const { ref, isVisible } = useScrollAnimation(0.1);

  return (
    <section
      id="business-model"
      ref={ref}
      className="relative py-24 md:py-32 lg:py-40 px-6 md:px-12 lg:px-20"
    >
      <div className="max-w-6xl mx-auto">
        <div
          className={`section-animate ${isVisible ? "visible" : ""} text-center mb-16 md:mb-20`}
        >
          <p className="text-xs md:text-sm tracking-[0.3em] text-text-muted mb-2">
            BUSINESS MODEL
          </p>
          <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold tracking-tight text-white mb-6 md:mb-8">
            成果条件を明確にし、改善を積み重ねる。
          </h2>
          <p className="text-sm md:text-base text-text-secondary leading-relaxed max-w-2xl mx-auto">
            広告成果に応じた報酬体系を基本とし、案件ごとに契約範囲、評価指標、報酬条件を定めます。
            成果を共通の軸に、継続的な検証と改善を通じて費用対効果の向上を目指します。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {steps.map((step, index) => (
            <div
              key={step.number}
              className={`section-animate ${
                isVisible ? "visible" : ""
              } relative p-6 md:p-8 border border-border/60 bg-surface/40 transition-all duration-500`}
              style={{
                transitionDelay: isVisible
                  ? `${0.1 * (index + 1)}s`
                  : "0s",
              }}
            >
              <div className="flex items-center justify-between mb-6">
                <div className="w-12 h-12 flex items-center justify-center border border-accent/40">
                  <i className={`${step.icon} text-xl text-accent`} />
                </div>
                <span className="text-3xl md:text-4xl font-bold text-accent/20 leading-none">
                  {step.number}
                </span>
              </div>

              <h3 className="text-base md:text-lg font-bold text-white mb-3 tracking-tight">
                {step.title}
              </h3>
              <p className="text-xs md:text-sm text-text-secondary leading-relaxed">
                {step.description}
              </p>

              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-accent/50 text-lg" />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}